<div class="d-flex flex-column content-wrapper flex-grow-1">
  <div class="pnf-upper d-flex flex-row flex-grow-1 align-items-center justify-content-center">
    <div class="d-flex flex-column align-items-center gap-5 text-center">
      <h1>{{ this.params?.title }}</h1>
      @if (this.params?.message) {
        <h4>{{ this.params?.message }}</h4>
      }
      @if (this.params?.buttonText) {
        <button type="button" pButton size="large" class="fw-bold" (click)="action()">
          {{ this.params?.buttonText }}
        </button>
      }
    </div>
  </div>
  <div class="pnf-lower d-flex flex-row">
    <div class="w-50 text-center pnf-lower-left">
      <img src="../../../assets/images/couch.png" alt="Couch" width="371px" />
    </div>
    <div class="w-50 text-center pnf-lower-right">
      <img src="../../../assets/images/table.png" alt="Couch" width="214px" />
    </div>
  </div>
</div>
